export const getStatusConfig = (status) => {
    console.log('status generate', status)
  switch (status) {
    case "SUCCESS":
    case "DELIVERED":
      return {
        bgColor: [235, 255, 234], // vert clair
        textColor: [52, 156, 50],
        label: " Réussi ✔",
      };

    case "PENDING":
      return {
        bgColor: [255, 248, 230], // jaune clair
        textColor: [255, 159, 0],
        label: " En attente ⏳",
      };

    case "CREATED":
      return {
        bgColor: [240, 242, 245], // gris clair
        textColor: [120, 120, 120],
        label: " Créé 📝",
      };

    case "REVERSED":
      return {
        bgColor: [230, 244, 255], // bleu clair
        textColor: [24, 144, 255],
        label: " Remboursé ↩",
      };

    case "CANCELED":
      return {
        bgColor: [245, 245, 245], // gris neutre
        textColor: [140, 140, 140],
        label: " Annulé 🚫",
      };

    case "REJECTED":
      return {
        bgColor: [255, 242, 242], // rouge clair
        textColor: [224, 9, 9],
        label: " Rejeté ✖",
      };

    default:
      return {
        bgColor: [255, 242, 242],
        textColor: [224, 9, 9],
        label: " statut non défini",
      };
  }
};